/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import StyledSettings from "./StyledSettings";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Modal, Typography } from "@mui/material";
import recoveryEmailIcon from "../../assets/icons/recoveryEmailIcon.svg";
import { useDispatch } from "react-redux";
import {
  DeleteAccount,
  fetchProfile,
  updateRecoveryEmail,
} from "../../store/reducers/home/apiThunk";
import {
  ToastNotifyError,
  ToastNotifySuccess,
} from "../../components/CommonComponents/Toast/ToastNotify";
import TextFeild from "../../components/CommonComponents/TextFeild";
import { ROUTE_PATH } from "../../constants/route";
import { useNavigate } from "react-router-dom";
import { CustomizedShimmer } from "../../components/CommonComponents/Shimmer";
import { fetchLogout } from "../../store/reducers/authentication/apiThunk";
import REGEX from "../../constants/constants";
import { BASIC_AUTHENTICATION_ERROR } from "../../constants/errorMessages";
import { resetBag } from "../../store/reducers/bag/apiThunk";

const Settings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(null);
  const [editEmail, setEditEmail] = useState(false);
  const [addEmail, setAddEmail] = useState(false);
  const [recoveryEamil, setRecoveryEamil] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [openDeleteAccountModal, setOpenDeleteAccountModal] = useState(false);

  const { EMAIL_PATTERN } = REGEX;

  const validateEmail = (email) => {
    // if (!email) {
    //   return BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_USERNAME_REQ;
    // }
    if(email){
    if (!EMAIL_PATTERN.test(email)) {
      return BASIC_AUTHENTICATION_ERROR.EMAIL;
    }
    if (email.length > 250) {
      return "Email should not be more than 250 characters";
    }
  }
    return "";
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    // Limit input to 30 characters
    if (email.length <= 30) {
      setRecoveryEamil(email);
    } else {
      setRecoveryEamil(email.slice(0, 30));
    }
    setEmailError(validateEmail(email.length <= 30 ? email : email.slice(0, 30)));
  };

  const getProfile = async () => {
    setLoading(true);
    try {
      const response = await dispatch(fetchProfile());
      const { data, message, status } = response?.payload;
      if (status) {
        setProfileData(data[0]);
        setLoading(false);
      } else {
        ToastNotifyError(message);
        setLoading(false);
      }
    } catch {
      setLoading(false);  
      ToastNotifyError("Failed to fetch profile");
    }
  };

  const andUpdateRecoveryEmail = async () => {
    const error = validateEmail(recoveryEamil);
    if (error) {
      setEmailError(error);
      return;
    }

    setLoading(true);
    const dataToSend = {
      recovery_email: recoveryEamil,
    };
    try {
      const response = await dispatch(updateRecoveryEmail(dataToSend));
      const { message, status } = response?.payload;
      if (status) {
        setAddEmail(false);
        setEditEmail(false);
        getProfile();
        setLoading(false);
        ToastNotifySuccess("Recovery email updated successfully");
      } else {
        setLoading(false);
        ToastNotifyError(message);
      }
    } catch {
      setLoading(false);
      ToastNotifyError("Failed to update recovery email");
    }
  };

  const fetchDeleteAccount = async () => {
    try {
      const res = await dispatch(DeleteAccount());
      const { status, message } = res?.payload;
      if (status) {
        dispatch(fetchLogout());
        dispatch(resetBag());
        ToastNotifySuccess("Account Deleted");
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (editEmail && profileData?.recovery_email) {
      setRecoveryEamil(profileData.recovery_email);
    }
  }, [profileData, editEmail]);
  
  return (
    <StyledSettings>
      {isLoading ? (
        <CustomizedShimmer />
      ) : (
        <Box className='settings-container'>
          <Box className='settings-header'>
            <ArrowBackIcon sx={{ fontSize: "20px", cursor: "pointer" }} onClick={() => navigate(ROUTE_PATH.USER_PROFILE)} />
            <Typography className='settings-title'>Settings</Typography>
          </Box>
          <Box className='recovery-email-wrap'>
            <Box className='recovery-email-icon-text-wrap'>
              <img src={recoveryEmailIcon} alt='' />
              <Box className='recovery-email-body'>
                <Typography className='recovery-email-title'>
                  Recovery email
                </Typography>
                <Typography className='recovery-email-text'>
                  Your recovery email is set as:
                </Typography>
              </Box>
            </Box>
            {profileData?.recovery_email && !editEmail ? (
              <>
                <TextFeild
                  value={profileData?.recovery_email}
                  disabled
                  className='recovery-email-textfield'
                  noLabel={true}
                />
                <Button
                  varient='outlined'
                  className='recovery-add-email-btn'
                  onClick={() => setEditEmail(true)}
                >
                  Edit email
                </Button>
              </>
            ) : editEmail ? (
              <>
                <TextFeild
                  value={recoveryEamil}
                  className='recovery-email-textfield'
                  noLabel={true}
                  onChange={handleEmailChange}
                  error={!!emailError}
                  helperText={emailError}
                  inputProps={{ maxLength: 30 }}
                />
                <Button
                  varient='contained'
                  className='recovery-update-email-btn'
                  onClick={andUpdateRecoveryEmail}
                  disabled={!!emailError}
                >
                  Save email
                </Button>
              </>
            ) : addEmail ? (
              <>
                <TextFeild
                  value={profileData?.recovery_email}
                  className='recovery-email-textfield'
                  noLabel={true}
                  onChange={handleEmailChange}
                  error={!!emailError}
                  helperText={emailError}
                  placeholder="Enter recovery email"
                  inputProps={{ maxLength: 30 }}
                />
                <Button
                  varient='contained'
                  className='recovery-update-email-btn'
                  onClick={andUpdateRecoveryEmail}
                  disabled={!!emailError}
                >
                  Save email
                </Button>
              </>
            ) : (
              <Button
                varient='outlined'
                className='recovery-add-email-btn'
                onClick={() => setAddEmail(true)}
              >
                Add email
              </Button>
            )}
          </Box>
          <Box className='delete-account-wrap'>
            <DeleteOutlineOutlinedIcon
              sx={{ fontSize: "24px", color: "#B60218" }}
            />
            <Box className='delete-account-body' onClick={() => setOpenDeleteAccountModal(true)}>
              <Typography className='delete-account-title'>
                Delete account
              </Typography>
              <Typography className='delete-account-text'>
                Deleting your account will permanently remove your data.
              </Typography>
            </Box>
          </Box>
          <Modal open={openDeleteAccountModal} onClose={() => setOpenDeleteAccountModal(false)}>
            <Box className='delete-account-modal-container'>
              <Typography className='delete-account-modal-title'>
                Delete account?
              </Typography>
              <Typography className='delete-account-modal-body'>
              Are you sure you want to delete your account?
              </Typography>
              <Box className='delete-account-modal-btns'>
                <Button
                  varient='outlined'
                  className='delete-account-modal-cancel-btn'
                  onClick={() => setOpenDeleteAccountModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  varient='contained'
                  className='delete-account-modal-delete-btn'
                  onClick={() => fetchDeleteAccount()}
                >
                  Delete
                </Button>
              </Box>
            </Box>
          </Modal>

        </Box>
      )}
    </StyledSettings>
  );
};

export default Settings;
